// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__oNGtC","modalContainer":"Modal_modalContainer__KTOO8","closeModalContainer":"Modal_closeModalContainer__z4CZ2","icon":"Modal_icon__Kfxas"};